import { number } from "echarts";
import { CHANNELTYPE } from "../../services/data";
import axiosClient, {
  ResponsePostSuccess,
  ResponsePostSuccessData,
  ResponseSuccess,
  ResponseSuccessTotal,
} from "../axiosClient";

export const activeArray = ["Chưa kích hoạt", "Đang sử dụng"];
export const statusCarInUse = [
  {
    value: "0",
    label: "Đã bán",
  },
  {
    value: "1",
    label: "Đang sử dụng",
  },
  {
    value: "2",
    label: "Đang sữa chữa",
  },
];
export interface IListCustomer {
  id: number;
  name: string;
  CCCD?: any;
  phone: string;
  birthday: string;
  gender: number;
  profession: string;
  statusMarital: number;
  address: string;
  email: string;
  province: string;
  interestedCar: string;
  rankTitle: RankTitle;
}
export interface IListCustomerBenefit {
  id: number;
  name: string;
  phone: string;
}
export interface RankTitle {
  id?: any;
  title: string;
  icon?: any;
}
export interface IPhone {
  id: number;
  phone: string;
}
export interface dataConvert {
  id: number;
  title: string;
  level: number;
  parentId: number | null;
}
export interface UnitLevel {
  id: number;
  code: string;
  title: string;
  view: number;
  level: number;
  parentId: any;
  children: Children[];
}
export interface Children {
  id: number;
  code: string;
  title: string;
  view: number;
  level: number;
  parentId: number;
  children: Children[];
}
export interface relationshipProp {
  name: string;
  hobby: number[];
  relationship: number | null;
}
export interface ISelectOption {
  value: number;
  label: string;
  vehicleId?: string
}

export interface Phone {
  type: number;
  phone: string;
}
export interface IProvince {
  id: number;
  areaId: number;
  title: string;
}

export interface IDistrict {
  id: number;
  title: string;
}

export interface IHobby {
  id: number;
  title: string;
}

export interface ITag {
  id: number;
  title: string;
  vehicleId?: number
}
export interface ITag_V2 {
  id: number;
  taxCode: string;
  username: string;
}
export interface IGroup {
  title: string;
  id: number;
}

export interface ICarCompany {
  id: number;
  vehicleId: number
  title: string;
  image: string;
}
export interface ICar {
  id: number;
  title: string;
  image: string;
  seatingCapacity: number;
  carLinesTitle: string;
  categoryCar: string;
}

export interface IRelative {
  id: number;
  title: string;
}


export interface IRelativeV2 {
  id: number | string;
  title: string;
}

export interface IRank {
  id: number;
  description: any;
  title: string;
}
export interface IArea {
  id: number;
  title: string;
  countCustomer: number;
  province: Province[];
}

export interface Province {
  id: number;
  title: string;
  customerCount: number;
}
export interface ICategoryCar {
  id: number;
  title: string;
  image: string;
  historyCount: number;
}
export interface IUnitOption {
  id: number;
  code: string;
  title: string;
  parentId: number;
  view: number;
  level: number;
}
export interface IUnitOptionV2 {
  id: number;
  title: string;
}
// Khối nghiệp vụ
export interface IBusinessUnit {
  id: number;
  code: string;
  title: string;
  status: number;
}
export interface IListAgent {
  id: number;
  code: string;
  title: string;
}

export interface ITemplate {
  id: number;
  title: string;
  status: number;
  description: string;
  code: string;
  targetId: number;
  iamgeTypeZNS: string;
}

export interface IUnitChild {
  id: number;
  code: string;
  title: string;
  parentId: number;
  view: number;
  level: number;
}
export interface Daum {
  id: number;
  username: string;
  CCCD?: string;
}

export interface ICCCDCustomer {
  id: number;
  username: string;
  CCCD: string;
}
export interface provinceUnit {
  id: number;
  title: string;
  code: string;
  unitId: string;
}
export interface ICodeCustomer {
  id: number;
  code: string;
  username: string;
  unitId: number;
  phone: string;
}
export interface IprovinceChild {
  id: number;
  title: string;
  districts: District[];
}

export interface District {
  id: number;
  title: string;
}

export interface IFieldByRerordAll {
  id: number
  fieldLabel: string
  fieldCode: string
}

export interface ISelectOptionMentions {
  value: string;
  label: string;
}

export interface ISelectOptiongTemplateZaloFromConek {
  value: number;
  label: number;
  content: string
}

export interface ISLContractsAndInvoices {
  label: string
  total: number
  children: Array<{
    id: number
    contractNo?: string
    invoiceServiceDocNo?: string
    type: number
  }>
}



export interface ISLCustomerFields {
  id: number
  title: string
  children: Array<{
    id: number
    fieldCode: string
    fieldLabel: string
    inputType: string
  }>
}


export type ICarePolicyBenefitsTree = {
  id: number
  code: string
  title: string
  children: ICarePolicyBenefitsTreeChildren[]
}

export interface ICarePolicyBenefitsTreeChildren {
  id: number
  title: string
  code: string
  description: string
  children: ICarePolicyBenefitsTreeChildren[]
}

export const getListBrandName = async () => {
  const path = "/integrationProviders/listBrandName";
  const params = {
  };
  const result: ResponsePostSuccessData<District[]> = await axiosClient.get(
    path,
    { params }
  );
  return result;
};

export const getListCampaign = async (search?: string) => {
  const path = "/apiChild/listCampaign";
  const params = {
    search
  };
  const result: ResponseSuccess<District[]> = await axiosClient.get(
    path,
    { params }
  );
  return result;
};

export const getListInformationChannel = async (search?: string) => {
  const path = "apiChild/listInformationChannel";
  const params = {
    search
  };
  const result: ResponseSuccess<District[]> = await axiosClient.get(
    path,
    { params }
  );
  return result;
};

export const getListProvinceChild = async (search?: string) => {
  const path = "/apiChild/listProvince";
  const params = {
    search
  };
  const result: ResponseSuccess<IprovinceChild[]> = await axiosClient.get(
    path,
    { params }
  );
  return result;
};

export const getListCodeCustomer = async (
  permittedCategoryCarIds: number[],
  businessCheck?: number, search?: string, unitId?: number, customerId?: number,
  limit: number = 20, pageNumber?: number, type?: number
) => {
  const path = "apiChild/listCodeCustomer";
  const params = {
    permittedCategoryCarIds,
    businessCheck, search, unitId, customerId,
    limit, pageNumber
  };
  const result: ResponseSuccessTotal<ICodeCustomer[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};


export const deleteBusinessUnit = async (id: number) => {
  const path = "businessUnit/deleteBusinessUnit";
  const params = {
    id,
  };
  const result: ResponseSuccess<[]> = await axiosClient.delete(path, {
    params,
  });
  return result;
};
export const addBusinessUnit = async (code: string, title: string) => {
  const path = "businessUnit/addBusinessUnit";
  const params = {
    code,
    title,
  };
  const result: ResponseSuccess<[]> = await axiosClient.post(path, params);
  return result;
};
export const editBusinessUnit = async (
  id: number,
  code: string,
  title: string
) => {
  const path = "businessUnit/editBusinessUnit";
  const params = {
    id,
    code,
    title,
  };
  const result: ResponseSuccess<[]> = await axiosClient.put(path, params);
  return result;
};

export const getInfoBusinessUnit = async (id: number) => {
  const path = "businessUnit/infoBusinessUnit";
  const params = {
    id,
  };
  const result: ResponseSuccess<IBusinessUnit> = await axiosClient.get(path, {
    params,
  });
  return result;
};

export const getListBusinessUnit = async () => {
  const path = "businessUnit/listBusinessUnit";
  const result: ResponseSuccess<IBusinessUnit[]> = await axiosClient.get(
    path,
    {}
  );
  return result;
};
// end khối nghiệp vụ


export const getSLUnitOption = async (search?: string) => {
  const path = "apiChild/listUnit";
  const params = { search };
  const result: ResponseSuccessTotal<IUnitOption[]> = await axiosClient.get(
    path,
    { params }
  );
  return result;
};
// option khách hàng cho Phát hành thẻ
export const getListUnreleased = async () => {
  const path = "rank/listUnreleased";
  const result: ResponseSuccess<IListCustomerBenefit[]> = await axiosClient.get(
    path,
    {}
  );
  return result;
};

export const getlistCustomer = async () => {
  const path = "customer/listCustomer";
  const result: ResponseSuccess<IListCustomer[]> = await axiosClient.get(
    path,
    {}
  );
  return result;
};

export const getListAgent = async () => {
  const path = "apiChild/listAgent";
  const result: ResponseSuccess<IListAgent[]> = await axiosClient.get(path, {});
  return result;
};

export const getValidatePhone = async (phone?: string[]) => {
  const path = "apiChild/validatePhone";
  const params = { phone };
  const result: ResponseSuccess<IPhone[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

export const getValidateMail = async (email: string) => {
  const path = "apiChild/validateEmail";
  const params = { email };
  const result: ResponseSuccess<[]> = await axiosClient.get(path, { params });
  return result;
};

export const getListNationwide = async (unitId?: number) => {
  const path = "unit/listNationwide";
  const params = { unitId }
  const result: ResponseSuccess<UnitLevel[]> = await axiosClient.get(path, { params });
  return result;
};

export const getAgentListNationwide = async () => {
  const path = "agent/listNationwide";
  const result: ResponseSuccess<UnitLevel[]> = await axiosClient.get(path, {});
  return result;
};



export const getListCategoryCar = async () => {
  const path = "filter/categoryCar";
  const result: ResponseSuccess<ICategoryCar[]> = await axiosClient.get(
    path,
    {}
  );
  return result;
};

export const getListArea = async () => {
  const path = "filter/area";
  const result: ResponseSuccess<IArea[]> = await axiosClient.get(path, {});
  return result;
};

export const getListRank = async () => {
  const path = "rank/listRank";
  const result: ResponseSuccess<IRank[]> = await axiosClient.get(path, {});
  return result;
};

export const getListProvince = async (search?: string) => {
  const path = "province/listProvince";
  const params = { search };
  const result: ResponseSuccess<IProvince[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

export const getListDistrict = async (id: number, search?: string) => {
  const path = "province/listDistrict";
  const params = { id, search };
  const result: ResponseSuccess<IDistrict[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

export const getListHobby = async (search?: string) => {
  const path = "hobby/listHobby";
  const params = { search };
  const result: ResponseSuccess<IHobby[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

export const getListTag = async () => {
  const path = "tags/listTags";
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(path, {});
  return result;
};

export const getListGroup = async (search?: string, unitId?: number[]) => {
  const params = { search, unitId };
  const path = "apiChild/listGroupCustomer";
  const result: ResponseSuccessTotal<IGroup[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

export const getListCarCompany = async () => {
  const path = "apiChild/listCategoryCar";
  const result: ResponseSuccess<ICarCompany[]> = await axiosClient.get(
    path,
    {}
  );
  return result;
};

export const getListCar = async (
  categoryCarId?: number | null,
  search?: string
) => {
  const params = { categoryCarId, search };
  const path = "apiChild/listCar";
  const result: ResponseSuccess<ICar[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

export const getListRelatives = async () => {
  const path = "relatives/listRelatives";
  const result: ResponseSuccess<IRelative[]> = await axiosClient.get(path, {});
  return result;
};


//Danh sách mẫu thông báo
export const getListTemplate = async (
  channelId?: Number,
  integrationProviderId?: Number
) => {
  const path = "apiChild/listTemplate";
  const params = { channelId, integrationProviderId };
  const result: ResponseSuccess<ITemplate[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};



//Danh sách loại số điện thoại
export const getListTypePhone = async () => {
  const path = "apiChild/listTypePhone";
  const params = {};
  const result: ResponseSuccess<IUnitChild[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

//Danh sách hạng
export const getCLRankChild = async (search?: string) => {
  const path = "apiChild/listRank";
  const params = {
    search,
  };
  const result: ResponseSuccess<IUnitChild[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

//Danh sách nghề nghiệp
export const getCLProfession = async (search?: string) => {
  const path = "apiChild/listProfession";
  const params = {
    search,
  };
  const result: ResponseSuccessTotal<IUnitChild[]> = await axiosClient.get(
    path,
    { params }
  );
  return result;
};

//Danh sách hạng
export const getCLRank = async (search?: string) => {
  const path = "apiChild/listStaff";
  const params = {
    search,
  };
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

//Danh sách hạng
export const getCLHobby = async (search?: string) => {
  const path = "apiChild/listHobby";
  const params = {
    search,
  };
  const result: ResponseSuccessTotal<ITag[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

//Danh sách nguồn hệ thống
export const getCLSourceCustomer = async () => {
  const path = "apiChild/listSourceCustomer";
  const params = {};
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

//Danh sách mã code tìm kiếm được
export const getCLTaxCodeBusiness = async (

  permittedCategoryCarIds: number[],
  customerId?: number, search?: string, unitId?: number, limit: number = 30, pageNumber?: number
) => {
  const path = "apiChild/seachTaxCodeBusiness";
  const params = {
    permittedCategoryCarIds,
    customerId, search, unitId, limit, pageNumber
  };
  const result: ResponseSuccessTotal<ITag_V2[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

//Danh sách mã code tìm kiếm được
export const getCLSeachCCCDCustomer = async (search?: string) => {
  const path = "apiChild/seachCCCDCustomer";
  const params = {
    search,
  };
  const result: ResponseSuccess<ICCCDCustomer[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};
// danh sách loại hỗ trợ
export const getTypeSupport = async () => {
  const path = "apiChild/getListTypeSupport";
  const params = {};
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

// danh sách nguồn mạng xã hội
export const getSourceSocial = async () => {
  const path = "apiChild/getListSupportChannel";
  const params = {};
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

// Danh sách mối quan hệ doanh nghiệp
export const getBusinessRelationship = async () => {
  const path = "apiChild/listBusinessRelationship";
  const params = {};
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

// Danh sách lĩnh vực kinh doanh doanh nghiệp
export const getBusinessField = async (search?: string) => {
  const path = "apiChild/listBusinessField";
  const params = { search };
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};
// Danh sách tỉnh thành đơn vị
export const getProvinceUnit = async (unitId?: number) => {
  const path = "apiChild/listProvinceUnit";
  const params = {
    unitId,
  };
  const result: ResponseSuccess<provinceUnit[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

// // Danh sách tỉnh thành đơn vị
// export const getCLContactMethod = async () => {
//   const path = "apiChild/listContactMethod";
//   const params = {};
//   const result: ResponseSuccess<IRelative[]> = await axiosClient.get(path, {
//     params,
//   });
//   return result;
// };


// lọc dk new
export const getSLlistFilter = async (search?: string, isCustomer?: number) => {
  const path = "apiChild/listFilter";
  const params = {
    search, isCustomer
  };
  const result: ResponseSuccess<ISelectOption[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};


export const deleteFilter = async (id: number) => {
  const path = "groupCustomerV2/deleteFilter";
  const params = {
    id,
  };
  const result: ResponseSuccess<[]> = await axiosClient.delete(path, {
    params,
  });
  return result;
};

// Danh sách field theo nhóm ALL
export const getSLFieldByRerordAll = async (recordId: number) => {
  const path = "apiChild/listFieldByRerord";
  const params = {
    recordId
  };
  const result: ResponseSuccess<IFieldByRerordAll[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

export const getSLUnitByPermission = async (unitId: number) => {
  const path = "/apiChild/listUnitByPermission";
  const params = {
    unitId
  };
  const result: ResponseSuccess<UnitLevel[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

export const getSLListIssuingUnit = async (unitId: number, search?: string) => {
  const path = "/issuingUnit/listIssuingUnit";
  const params = {
    unitId,
    search
  };
  const result: ResponseSuccess<UnitLevel[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};


export const getSLCategoryCarByPermission = async (permittedCategoryCarIds: number[]) => {
  const path = "apiChild/listCategoryCarByPermission";
  const params = {
    permittedCategoryCarIds
  };
  const result: ResponseSuccess<IDistrict[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};


export const getSLProfitCenterName = async (
  search?: string
) => {
  const path = "apiChild/listProfitCenterName";
  const params = {
    search
  };
  const result: ResponseSuccess<IDistrict[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

export const getSLVehicleEngineNos = async (
  customerId: number, vehicleId: number,
  plateNumberId?: string, chassisNo?: string
) => {
  const path = "apiChild/VehicleEngineNos";
  const params = {
    customerId, vehicleId,
    plateNumberId, chassisNo
  };
  const result: ResponseSuccess<IDistrict[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

export const getSLQuestionSurvey = async (
) => {
  const path = "apiChild/listQuestionSurvey";
  const params = {
  };
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

//	Danh sách option của câu hỏi
export const getSLAnswerOptions = async (
  questionId: number
) => {
  const path = "apiChild/listAnswerOptions";
  const params = {
    questionId
  };
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

//	Danh sách option của Danh sách nhà cung cấp
export const getSLSmsProvider = async (
) => {
  const path = "/apiChild/listSmsProvider";
  const params = {
  };
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(path, {
    params,
  });
  return result;
};

//Danh sách nhà cung cấp ZNS
export const getSLZnsProvider = async (
) => {
  const path = "/apiChild/listZnsProvider"
  const params = {
  }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách nhà cung cấp ZNS
export const getSLParameters = async (
) => {
  const path = "/apiChild/listParameters"
  const params = {
  }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách nhà cung cấp ZNS
export const getSLTemplate = async (
  type: CHANNELTYPE,
  id?: number,
) => {
  const path = "/apiChild/listTemplate"
  const params = {
    type,
    id,
  }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách loại hoạt động áp dụng
export const getSLActivityType = async (
  search?: string
) => {
  const path = "/apiChild/listActivityType"
  const params = {
    search
  }
  const result: ResponseSuccess<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


//Danh sách loại hoạt động áp dụng
export const getSLChassisNoByCustomerId = async (
  customerId: number
) => {
  const path = "/apiChild/chassisNoByCustomerId"
  const params = {
    customerId
  }
  const result: ResponseSuccessTotal<ITag[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export interface ISLVoucherInCampaign {
  id: number
  title: string
  quantity: number
  type: number
}

export const getSlVoucherInCampaign = async (search?: string, idEdit?: number) => {
  const path = "/apiChild/listVoucherInCampaign";
  const params = {
    search, idEdit
  }
  const result: ResponseSuccess<ISLVoucherInCampaign[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getSlContractsAndInvoices = async (customerId: number, search?: string) => {
  const path = "apiChild/listContractsAndInvoices";
  const params = {
    customerId, search
  }
  const result: ResponseSuccess<ISLContractsAndInvoices[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};




// Tham số cho ZNS, Email
export const getSlListCustomerFieldsV2 = async (limit?: number, pageNumber?: number, search?: string, listSources?: number[], listRecords?: number[]) => {
  const path = "profileCustomer/listCustomerFields";
  const params = {
    limit, pageNumber, search, listSources, listRecords,
  }
  const result: ResponseSuccess<ISLCustomerFields[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};




export const getListCarePolicyBenefitsTree = async (
  search?: string, rankId?: number
) => {
  const path = "/apiChild/listCarePolicyBenefitsTree"
  const params = {
    search, rankId
  }
  const result: ResponseSuccessTotal<ICarePolicyBenefitsTree[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
